import { useState } from "react";
import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "漫画分类",
    links: [
      { name: "热血漫画", path: "/category/all" },
      { name: "恋爱漫画", path: "/category/all" },
      { name: "玄幻漫画", path: "/category/all" },
      { name: "耽美漫画", path: "/category/all" },
      { name: "恐怖漫画", path: "/category/all" },
      { name: "搞笑漫画", path: "/category/all" },
    ],
  },
  {
    title: "热门推荐",
    links: [
      { name: "排行榜", path: "/category/all" },
      { name: "最新更新", path: "/" },
      { name: "本月热门", path: "/" },
      { name: "完结推荐", path: "/" },
      { name: "新作上线", path: "/" },
      { name: "编辑精选", path: "/" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { name: "品牌介绍", path: "/about" },
      { name: "联系我们", path: "/about" },
      { name: "用户协议", path: "/about" },
      { name: "隐私政策", path: "/about" },
      { name: "版权声明", path: "/about" },
      { name: "帮助中心", path: "/about" },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get("website_alt") as string || "").trim();
    if (honeypotValue) {
      setStatus("success");
      setStatusMsg("订阅成功！感谢你的关注~");
      setEmail("");
      return;
    }

    try {
      const res = await fetch("http://i0767.com/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email: formData.get("email") as string }).toString(),
      });
      const responseText = await res.text();
      const parsed = JSON.parse(responseText);

      if (res.ok && parsed?.code === "OK") {
        setStatus("success");
        setStatusMsg("订阅成功！感谢你的关注~");
        setEmail("");
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || "订阅失败";
        setStatus("error");
        setStatusMsg(serverMsg);
      }
    } catch {
      setStatus("error");
      setStatusMsg("网络错误，请稍后重试");
    }
  };

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-0">
          <div className="lg:w-[40%]">
            <h4 className="text-3xl font-black tracking-tighter text-white font-heading">
              汗汗<span className="text-primary-400">漫画</span>
            </h4>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed max-w-xs">
              更新最快的漫画网，提供好看的免费漫画大全与无遮挡韩漫。追求极致内容时效性与阅读体验。
            </p>

            <div className="mt-8">
              <form
                id="newsletter-form"
               
                onSubmit={handleSubscribe}
              >
                <label htmlFor="footer-email" className="block text-xs text-foreground-400 mb-2">
                  订阅更新通知
                </label>
                <div className="flex flex-col sm:flex-row gap-2">
                  <input
                    id="footer-email"
                    name="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="输入你的邮箱"
                    className="flex-1 bg-transparent border-b border-foreground-600 px-2 py-2.5 text-sm text-white placeholder-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                  <button
                    type="submit"
                    className="px-5 py-2.5 rounded-lg border border-foreground-500 text-sm text-white hover:bg-primary-500 hover:border-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    订阅
                  </button>
                </div>
                <div className="honeypot-field">
                  <input name="website_alt" type="text" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                {status !== "idle" && (
                  <p className={`mt-2 text-xs ${status === "success" ? "text-primary-400" : "text-accent-400"}`}>
                    {statusMsg}
                  </p>
                )}
              </form>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-6">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h5 className="text-sm font-semibold text-white mb-4 font-heading">
                  {col.title}
                </h5>
                <ul className="flex flex-col gap-2.5">
                  {col.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-700/40">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 汗汗漫画 HanHanMH.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">
                <i className="ri-wechat-line mr-1"></i>微信公众号
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors" rel="nofollow">
                <i className="ri-weibo-line mr-1"></i>微博
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}